var map = {
	"./1.png": 189,
	"./6.png": 370,
	"./Bhavya1.png": 759,
	"./DRAWINGA.jpg": 168,
	"./MATH pre-primer.jpg": 367,
	"./MATH primer.jpg": 186,
	"./SHABD LEKHAN.jpg": 664,
	"./SWAR GYAN.jpg": 209,
	"./SWAR LEKHAN.jpg": 910,
	"./akshar lekhan.jpg": 992,
	"./alphabet.jpg": 10,
	"./book2.png": 115,
	"./capital and small writing.jpg": 43,
	"./capital writing.jpg": 75,
	"./drawing b.jpg": 713,
	"./drawing.jpg": 27,
	"./eco.jpg": 860,
	"./english primer.jpg": 578,
	"./englishpre-primer.jpg": 951,
	"./number.jpg": 955,
	"./picture book a.jpg": 46,
	"./picture book b.jpg": 510,
	"./sahbd gyan.jpg": 641,
	"./small writing.jpg": 272,
	"./yellow.png": 635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;